import { worldCitiesSchema } from "@/schemas/world-city-schema";
import { IFetchWorldCitiesResult } from "@/types/world-cities-type";

export const fetcWorldCities = async (): Promise<IFetchWorldCitiesResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/world_forecast/world_location.geojson",
		);

		if (!res.ok) {
			throw new Error("An error occurred");
		}

		const data = await res.json();

		const validatedData = worldCitiesSchema.parse(data);

		return {
			isLoading: false,
			error: null,
			worldCitiesData: validatedData.features,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			worldCitiesData: [],
		};
	}
};
